export default () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="19" fill="white" stroke="#955CA9" strokeWidth="2" />
    <g clipPath="url(#clip0_79:265)">
      <path
        d="M15.9995 12C15.5579 12 15.1988 12.3591 15.1988 12.8007V13.6013H14.4001C13.0848 13.6013 12 14.6862 12 16.0014V25.6018C12 26.9171 13.0848 28.0019 14.4001 28.0019H25.5999C26.9152 28.0019 28 26.9171 28 25.6018V16.0014C28 14.6862 26.9152 13.6013 25.5999 13.6013H24.7992V12.8007C24.7992 12.3591 24.4402 12 23.9986 12C23.5569 12 23.1979 12.3591 23.1979 12.8007V13.6013H16.8002V12.8007C16.8002 12.3591 16.4411 12 15.9995 12ZM14.4001 15.2008H15.2008V16.0014C15.2008 16.4431 15.5598 16.8021 16.0014 16.8021C16.4431 16.8021 16.8021 16.4431 16.8021 16.0014V15.2008H23.2017V16.0014C23.2017 16.4431 23.5608 16.8021 24.0024 16.8021C24.444 16.8021 24.8031 16.4431 24.8031 16.0014V15.2008H25.6037C26.0607 15.2008 26.4044 15.5445 26.4044 16.0014V18.4015H13.5994V16.0014C13.5994 15.5425 13.9431 15.2008 14.4001 15.2008ZM13.5994 20.001H26.4006V25.6018C26.4006 26.0588 26.0569 26.4025 25.5999 26.4025H14.4001C13.9431 26.4025 13.5994 26.0588 13.5994 25.6018V20.001Z"
        fill="#955CA9"
      />
    </g>
    <defs>
      <clipPath id="clip0_79:265">
        <rect width="16" height="16" fill="white" transform="translate(12 12)" />
      </clipPath>
    </defs>
  </svg>
);
